import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Calendar, Users } from 'lucide-react';
export function UpsellSection() {
  return <Section background="darker" className="border-t border-slate-800" data-id="element-155">
      <div className="max-w-4xl mx-auto bg-slate-900/80 p-8 rounded-2xl border border-blue-500/10 text-center" data-id="element-156">
        <h3 className="text-xl font-bold text-white mb-2" data-id="element-157">
          ¿Quieres un plan personalizado?
        </h3>
        <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/20 text-amber-400 text-sm font-medium px-4 py-1.5 rounded-full mb-6" data-id="element-158">
          <Users className="h-4 w-4" data-id="element-159" />
          Plazas limitadas: solo 5 sesiones disponibles esta semana
        </div>

        <p className="text-slate-300 mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-160">
          Si quieres que adapte esto a tu caso y te dé un plan personalizado,
          agenda una llamada.
          <span className="text-white font-semibold" data-id="element-161">
            {' '}
            Sesión Diagnóstico 1:1 — 29€.
          </span>{' '}
          Sales con reglas y límites exactos, más un plan de 7 días.
        </p>

        <p className="text-slate-400 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-162">
          Además, en la sesión te mostraré el camino exacto para consolidar tu
          disciplina durante los próximos meses.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-163">
          <Button variant="outline" className="border-slate-600 text-slate-300 hover:text-white hover:border-white" data-id="element-164">
            <Calendar className="mr-2 h-4 w-4" data-id="element-165" />
            Sesión Diagnóstico 1:1 (29€)
          </Button>
        </div>
        <p className="text-xs text-slate-500 mt-4" data-id="element-166">
          (Se descuenta si entras al programa anual)
        </p>
      </div>
    </Section>;
}